import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ProductIndicatorBadge from 'common/ProductIndicatorBadge';
import AuthorizationVolumes from '../components/AuthorizationVolumes';

const ProductDetails = ({ product, info }) => {
  const { productNameShort, productIdName, proprietary } = product;

  // productIndex :: Product -> Number
  const productIndex = R.not(R.isNil(R.prop('products', info)))
    ? R.findIndex(R.equals(product), R.prop('products', info))
    : 0;

  return (
    <Accordion
      defaultExpanded
      sx={{ '&:before': { display: 'none' }, backgroundColor: 'transparent', boxShadow: 'none' }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: 44, px: 0 }}>
        <Stack direction="row" spacing={1}>
          <Box
            alignItems="center"
            borderRadius="4px"
            display="flex"
            height={20}
            justifyContent="center"
            p={0.5}
            sx={{ backgroundColor: 'graphic.light', color: 'text.secondary' }}
            width={32}
          >
            {productIdName}
          </Box>
          <Typography>{productNameShort}</Typography>
          <ProductIndicatorBadge proprietary={proprietary} />
        </Stack>
      </AccordionSummary>

      <AccordionDetails sx={{ backgroundColor: 'surface.white', p: 0 }}>
        <AuthorizationVolumes dataPath={['products', productIndex]} isProduct />
      </AccordionDetails>
    </Accordion>
  );
};

ProductDetails.propTypes = {
  info: PropTypes.shape({}),
  product: PropTypes.shape({
    productIdName: PropTypes.string,
    productNameShort: PropTypes.string,
    proprietary: PropTypes.bool,
  }).isRequired,
};

ProductDetails.defaultProps = {
  info: {},
};

export default ProductDetails;
